// Play a poll request
export const PLAY_A_POLL_REQUEST = 'PLAY_A_POLL_REQUEST'
export const PLAY_A_POLL_SUCCESS = 'PLAY_A_POLL_SUCCESS'
export const PLAY_A_POLL_FAILURE = 'PLAY_A_POLL_FAILURE'

// Renew a poll
export const RENEW_A_POLL_REQUEST = 'RENEW_A_POLL_REQUEST';
export const RENEW_A_POLL_SUCCESS = 'RENEW_A_POLL_SUCCESS';
export const RENEW_A_POLL_FAILURE = 'RENEW_A_POLL_FAILURE';